export const UNAVAILABLE_STATUSES = new Set([
  "booked",
  "external-booking",
  "rented-from-bureau",
  "own-use",
  "season-blocked",
  "reservation",
  "changeover-day",
]);
